import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import AboutSection from "@/pages/home/components/AboutSection";
import MenuSection from "@/pages/home/components/MenuSection";
import GallerySection from "@/pages/home/components/GallerySection";
import CTASection from "@/pages/home/components/CTASection";
import ContactSection from "@/pages/home/components/ContactSection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <MenuSection />
        <GallerySection />
        <TestimonialsSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
